/* !
 * Check if value is white.
 * @param  {string}     value       The value to check if it's white
 * @return {boolean}                Is the value white or not
 */
const isWhite = value => `${value}`.match(/^(#fff|#ffffff|#ffffffff)$/);

export default isWhite;
